var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid d-flex flex-wrap justify-content-between"},[_c('nav',[_c('ul',[_c('li',[_vm._v("\n          eGas · QSStorage\n        ")])])]),_c('div',{staticClass:"copyright d-flex flex-wrap"},[_vm._v("\n      © eGas Todos los derechos reservados\n    ")])])])
}]

export { render, staticRenderFns }